module.exports = __webpack_public_path__ + "img/slide-2.d646698a.jpeg";